'use client';
import { useState } from "react";
import {Button} from "@mantine/core";
import ProductGrid from "../product/ProductGrid";

export default function CollectionProducts({initialProducts, catSlug, nextPage,labelMap}) {
    const [products, setProducts] = useState(initialProducts);
    const [page, setPage] = useState(2);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(!!nextPage);
    async function loadMore() {
        try {
            setLoading(true);
            const res = await fetch(`/api/collections/${catSlug}?page=${page}`);
            const data = await res.json();
            const newProducts = data?.cat?.catpros?.data || [];
            setProducts(prev => [...prev, ...newProducts]);
            setHasMore(!!data?.cat?.catpros?.next_page_url);
            setPage(prev => prev + 1);
        } catch(error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <ProductGrid products={products} labelMap={labelMap}/>
            {hasMore && (
                <div className={'text-center mt-6'}>
                    <Button onClick={loadMore} disabled={loading} tt={'uppercase'}>
                        {loading
                            ? 'Loading...'
                            : 'Load More'}
                    </Button>
                </div>
            )}
        </>
    );
}